import { StandardReportType } from 'types/reporting';
import { PortfolioEnergyAndRevenue } from './reportTypes/portfolioEnergyRevenue/PortfolioEnergyAndRevenue';

interface ReportReportTypeProps {
    studyId: number;
    reportType: StandardReportType;
}

export function ReportType({ studyId, reportType }: ReportReportTypeProps) {
    switch (reportType) {
        case 'PortfolioEnergyAndRev':
            return <PortfolioEnergyAndRevenue studyId={studyId} />;
        default:
            return <div>Report type {reportType} not implemented.</div>;
    }
}
